import {
  PostApiTimesheetsError,
  PostApiTimesheetsResponse,
  PostApiTimesheetsVariables,
  usePostTimesheet as usePostApiTimesheet,
  usePostTimesheetRow,
} from '@sit/client-shared';
import { UseMutationOptions } from '@tanstack/react-query';
import { track } from '@web/analytics/analyticsClient';
import trackEvents from '@web/analytics/trackEvents';
import { getTimesheetRoute } from '@web/containers/Timesheet/helpers/routes';
import { useIncludeEntityData } from '@web/containers/Timesheets/hooks/useIncludeEntityData';
import { useIsStaff } from '@web/containers/Timesheets/hooks/useIsStaff';
import { setSyncStatus } from '@web/services/timesheet-sync-status';
import { useNavigate } from 'react-router';
import { v4 } from 'uuid';

export function usePostTimesheet(
  options?: Omit<UseMutationOptions<PostApiTimesheetsResponse, PostApiTimesheetsError, PostApiTimesheetsVariables>, 'mutationFn'>,
) {
  const staff = useIsStaff();
  const includeEntityData = useIncludeEntityData();
  const navigate = useNavigate();
  const { mutateAsync: createTimesheetRow } = usePostTimesheetRow();
  return usePostApiTimesheet({
    ...options,
    onSuccess: (data) => {
      createTimesheetRow({
        pathParams: { timesheetId: data.id },
        body: {
          id: v4(),
        },
      });
      setSyncStatus({ timesheetId: data.id, synced: false });

      navigate(getTimesheetRoute(data.id, { staff, includePrivate: includeEntityData }));
      track(trackEvents.TIMESHEET_CREATE);
    },
  });
}
